import { Button } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import BSTNAnimation from '@/components/Animations/BSTNAnimation';
import AppLink from '@/components/AppLink';
import AlertOctagonIcon from '@/components/Icons/AlertOctagonIcon';
import { useLoggedIn } from '@/hooks';
import { links } from '@/localization';
import reloadPage from '@/utils/device/reloadPage';
import { usePylon } from '@bolasim/react-use-pylon';

import { AnimationWrapper, Container, Content } from './styled';

function Default() {
  const isLoggedIn = useLoggedIn();
  const { show } = usePylon();
  return (
    <Container alignItems="center" justifyContent="center">
      <AnimationWrapper>
        <BSTNAnimation />
      </AnimationWrapper>
      <Content alignItems="center" justifyContent="center" gap={3}>
        <AlertOctagonIcon sx={{ width: 32, height: 32 }} />
        <Stack flexDirection="column" gap={1} alignItems="center">
          <Typography variant="mono1" sx={{ fontSize: 28, fontWeight: 500 }}>
            Something went wrong.
          </Typography>
          <Typography textAlign="center" color="text.muted">
            There was an issue loading the page. Try reloading below or{' '}
            {isLoggedIn ? (
              <AppLink onClick={show}>chat with support</AppLink>
            ) : (
              <AppLink href={links.basetenSupportEmail}>contact support</AppLink>
            )}
            .
          </Typography>
        </Stack>
        <Button variant="contained" color="primary" onClick={reloadPage}>
          Reload the page
        </Button>
      </Content>
    </Container>
  );
}

export { Default };
